module.exports = __webpack_public_path__ + "img/ic_wuxingxi@3x.7c7d8fa2.png";